// extracted by mini-css-extract-plugin
export default {"background":"DetailImage_background__F+Pbf","photo":"DetailImage_photo__i3fD-","photo__close":"DetailImage_photo__close__DuxoY"};